import React, { useState, useCallback, memo, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Box, Checkbox, Flex, HStack, VStack } from "@chakra-ui/react";
import { useParams } from 'react-router-dom';
import { PRODUCTS_TABS } from "../../constants/ui";
import FindSuppliers from "./FindSuppliers";
import SectorsInnerLayout from "./SectorsInnerLayout";
import CategorySize from "./CategorySize";
import SegmentActivity from "./SegmentActivity";
import Loader from "../../components/Loader/Loader";
import CompetitiveRisk from '../../pages/Client/Competitive/CompetitiveRisk';
import FindExperts from './FindExperts';
import {
  Input,
  InputGroup,
  InputRightElement,
  Text,
} from "@chakra-ui/react";
import { Search2Icon } from "@chakra-ui/icons";
import {
  RangeSlider,
  RangeSliderTrack,
  RangeSliderFilledTrack,
  RangeSliderThumb,
} from "@chakra-ui/react";
import UnlockRegistration from "../../shared/UnlockRegistration/UnlockRegistration";

// Memoized TabContent
const TabContent = memo(({ tab, clientData, sectorclientData }) => {
  const { sectorId } = useParams();
  const [revenueRange, setRevenueRange] = useState([10, 25]);
  const [productSearchTerm, setProductSearchTerm] = useState("");
  const [locationSearchTerm, setLocationSearchTerm] = useState(""); // input text
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [isInteracting, setIsInteracting] = useState(false);

  const suppliers = useSelector(
    state => Array.isArray(state.sectorSupplierReducer?.data) ? state.sectorSupplierReducer.data : []
  );

  const { isAuthenticatedUser } = useSelector((state) => state.userReducer);

  const sectorProducts = Array.from(
    new Set(
      suppliers.flatMap(supplier =>
        Array.isArray(supplier.products)
          ? supplier.products.map(p => p.product)
          : []
      )
    )
  );

  const [checkedProducts, setCheckedProducts] = useState([]);

  useEffect(() => {
    if (sectorProducts.length > 0 && checkedProducts.length === 0) {
      setCheckedProducts(sectorProducts);
    }
  }, [sectorProducts]);

  const productTypes = sectorProducts;

  // Filtered list for search
  const filteredProductTypes = sectorProducts
    .filter((type) =>
      type.toLowerCase().includes(productSearchTerm.toLowerCase())
    );

  const handleInteraction = () => {
    if (!isAuthenticatedUser) {
      setIsInteracting(true);
    }
  };

  const resetInteraction = () => {
    setIsInteracting(false);
  };
  const [showAll, setShowAll] = useState(false)
  switch (tab) {
    case PRODUCTS_TABS.CATEGORY_SIZE:
      return <CategorySize clientData={clientData} />;
    case PRODUCTS_TABS.COMPETITIVE_RISK:
      return <CompetitiveRisk />;
    case PRODUCTS_TABS.SME_ACTIVITY:
      return <SegmentActivity clientData={clientData} />;
      case PRODUCTS_TABS.SME_ACTIVITY:
      return <SegmentActivity clientData={clientData} />;
      case PRODUCTS_TABS.FIND_EXPERTS:
      return <FindExperts clientData={clientData} />;
    case PRODUCTS_TABS.FIND_SUPPLIERS:
      return (
        <Flex>
          <Box w="100%" h="calc(100% - var(--headerbar-height) - var(--footerbar-height))" p="10px">
            <Box margin="0px" className="SMEBackgroundBoxShadow">
              <HStack w="100%" spacing={4} alignItems="start" className="shadowBox">
                <Box
                  w="300px!important"
                  bg="#F8F8F8"
                // keep above content
                >
                  <VStack spacing={4} m={1} className="leftNavOptions" alignItems="flex-start" p="10px 3px">
                    <Text fontWeight="bold" fontSize="14px" mb="0">
                      Filter by
                    </Text>



                    <Box w="100%" position="relative" onMouseLeave={resetInteraction}>
                      <Text fontSize="13px" fontWeight="medium" mb={1}>
                        Product Type
                      </Text>

                      {/* Product List */}
                      <Box
                        maxH={showAll ? "200px" : "unset"}   // mid height when expanded
                        overflowY={showAll ? "auto" : "visible"}
                        pr={1} // small right padding so scrollbar doesn’t overlap content
                      >
                        {/* <VStack
      align="start"
      spacing={1}
      onMouseEnter={handleInteraction}
    >
      {(filteredProductTypes.length > 0 ? filteredProductTypes : productTypes)
        .slice(0, showAll ? undefined : 4) // show only 4 initially
        .map((type, index) => (
          <Checkbox
            key={type}
            size="md"
            fontSize="13px"
            isChecked={checkedProducts.includes(type)}
            onChange={(e) => {
              if (!isAuthenticatedUser) return;
              if (e.target.checked) {
                setCheckedProducts([...checkedProducts, type]);
              } else {
                setCheckedProducts(
                  checkedProducts.filter((p) => p !== type)
                );
              }
            }}
            onFocus={handleInteraction}
            disabled={!isAuthenticatedUser}
            sx={
              !isAuthenticatedUser && index >= 2
                ? { pointerEvents: "none" }
                : {
                    "& .chakra-checkbox__control": {
                      bg: "#9ca0a0ff",
                      borderRadius: "2px",
                      _checked: {
                        bg: "#F8FDFD",
                        color: "#4E6565",
                      },
                    },
                  }
            }
          >
            {type}
          </Checkbox>
        ))}
    </VStack> */}
                        <VStack align="start" spacing={1} onMouseEnter={handleInteraction}>
                          {(filteredProductTypes.length > 0 ? filteredProductTypes : productTypes)
                            .slice(0, showAll ? undefined : 4) // show only 4 initially
                            .map((type, index) => (
                              <Checkbox
                                key={type}
                                size="md"
                                fontSize="13px"
                                isChecked={checkedProducts.includes(type)}
                                onChange={(e) => {
                                  // toggle the checkbox normally
                                  if (e.target.checked) {
                                    setCheckedProducts([...checkedProducts, type]);
                                  } else {
                                    setCheckedProducts(
                                      checkedProducts.filter((p) => p !== type)
                                    );
                                  }
                                }}
                                onFocus={handleInteraction}
                                sx={{
                                  "& .chakra-checkbox__control": {
                                    bg: "#9ca0a0ff",
                                    borderRadius: "2px",
                                    _checked: {
                                      bg: "#F8FDFD",
                                      color: "#4E6565",
                                    },
                                  },
                                }}
                              >
                                {type}
                              </Checkbox>
                            ))}
                        </VStack>

                      </Box>


                      {(filteredProductTypes.length > 4 || productTypes.length > 4) && (
                        <Text
                          fontSize="12px"
                          color="blue.500"
                          cursor="pointer"
                          mt={1}
                          onClick={() => setShowAll(!showAll)}
                        >
                          {showAll ? "See Less" : "See more"}
                        </Text>
                      )}
                    </Box>





                    {/* Location */}
                    <Box w="100%">
                      <Text fontSize="13px" fontWeight="600" mb={1}>
                        LOCATION
                      </Text>

                      {/* Input with search icon */}
                      <InputGroup size="sm" mb={2}>
                        <Input
                          placeholder="Enter city, pincode"
                          fontSize="13px"
                          value={locationSearchTerm}
                          onChange={(e) => setLocationSearchTerm(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && locationSearchTerm.trim() !== "") {
                              // prevent duplicates
                              if (!selectedLocations.includes(locationSearchTerm.trim())) {
                                setSelectedLocations([...selectedLocations, locationSearchTerm.trim()]);
                              }
                              setLocationSearchTerm("");
                            }
                          }}
                        />
                        <InputRightElement pointerEvents="none">
                          <Search2Icon color="#30D5C8" boxSize={3} />
                        </InputRightElement>
                      </InputGroup>

                      {/* Selected locations (chips) */}
                      <Box display="flex" flexWrap="wrap" gap={2}>
                        {selectedLocations.map((loc, idx) => (
                          <Box
                            key={idx}
                            display="flex"
                            alignItems="center"
                            bg="#30D5C8"
                            px={3}
                            py={1}
                            borderRadius="md"
                          >
                            <Text fontSize="12px" color="white" mr={2}>
                              {loc}
                            </Text>
                            <Box
                              as="button"
                              onClick={() =>
                                setSelectedLocations(selectedLocations.filter((_, i) => i !== idx))
                              }
                              bg="white"
                              borderRadius="full"
                              w="16px"
                              h="16px"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              fontSize="10px"
                              fontWeight="bold"
                              color="gray.600"
                            >
                              ×
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </Box>



                    {/* Revenue Range */}
                    <Box w="100%">
                      <Text fontSize="13px" fontWeight="medium" mb={1}>
                        Revenue range
                      </Text>

                      <RangeSlider

                        aria-label={["min", "max"]}
                        value={revenueRange}
                        min={10}
                        max={30}
                        step={1}
                        onChange={(val) => setRevenueRange(val)}
                      >
                        <RangeSliderTrack bg="gray.200" h="5px">
                          <RangeSliderFilledTrack bgGradient="linear(to-r, #30D5C8, #FFAA00)" />
                        </RangeSliderTrack>
                        <RangeSliderThumb boxSize={3} index={0} bg="#30D5C8" />
                        <RangeSliderThumb boxSize={3} index={1} bg="#FFAA00" />
                      </RangeSlider>




                      <Box
                        display="flex"
                        justifyContent="space-between"
                        fontSize="12px"
                        mt={2}
                        alignItems="center"
                      >
                        <Box display="flex" alignItems="center" gap={2}>
                          <Text>From</Text>
                          <Input
                            value={`${revenueRange[0]} Cr`}
                            onChange={(e) => {
                              let val = parseInt(e.target.value.replace(/\D/g, ""));
                              if (!isNaN(val)) {
                                setRevenueRange([Math.max(10, Math.min(val, revenueRange[1])), revenueRange[1]]);
                              }
                            }}
                            w="70px"
                            size="sm"
                            fontSize="12px"
                          />
                        </Box>

                        <Box display="flex" alignItems="center" gap={2}>
                          <Text>To</Text>
                          <Input
                            value={`${revenueRange[1]} Cr`}
                            onChange={(e) => {
                              let val = parseInt(e.target.value.replace(/\D/g, ""));
                              if (!isNaN(val)) {
                                setRevenueRange([revenueRange[0], Math.min(30, Math.max(val, revenueRange[0]))]);
                              }
                            }}
                            w="70px"
                            size="sm"
                            fontSize="12px"
                          />
                        </Box>
                      </Box>
                    </Box>


                  </VStack>
                </Box>
                <Box mt={2} w="80%">
                  <FindSuppliers
                    productSearchTerm={productSearchTerm}
                    locationSearchTerm={locationSearchTerm}
                    revenueRange={revenueRange}
                    checkedProducts={checkedProducts}
                  />
                </Box>
              </HStack>
            </Box>
          </Box>
        </Flex>
      );
    default:
      return null;
  }
});

// Main component
const SectorDetails = () => {
  const { loading } = useSelector(
    state => ({
      loading: state.sectorReducer.loading,
      lastUpdated: state.sectorReducer.lastUpdated
    }),
    shallowEqual
  );

  const { client } = useSelector(
    state => ({ client: state.clientReducer.client }),
    shallowEqual
  );

  const [currentTab, setCurrentTab] = useState(PRODUCTS_TABS.CATEGORY_SIZE);

  const changeTab = useCallback((newTab) => {
    setCurrentTab(newTab);
  }, []);

  return (
    <>
      <SectorsInnerLayout currentTab={currentTab} changeTab={changeTab} />
      {loading ? (
        <Loader />
      ) : (
        <TabContent
          tab={currentTab}
          clientData={client?.details?.data}
          sectorclientData={client?.details?.data}
          products={client?.details?.data?.products}
        />
      )}
    </>
  );
};

export default memo(SectorDetails);